import { createTheme, type MantineTheme } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const baseTheme: PartialDeep<MantineTheme> = createTheme({
  cursorType: 'pointer',
});
